import { useState, useEffect } from "react";
import { useGerenciamento } from "../Context/GerenciamentoContext";
import { Link, useNavigate } from 'react-router-dom';
import "../../App.css";
import "./Forms.css";

import vendaIcon from "../../assets/icons/vendas.png";

import VendasService from "../../services/VendasService";
import ProdutosService from "../../services/ProdutosService";
import CadastrosInternosService from "../../services/CadastrosInternosService";
import FormaPagtoService from "../../services/FormaPagtoService";

import vendasDTO from "../../types/FormVendaDTO";

export default function VendaForm({ itemSelecionado, modo, onClose }) {

  const { setRetorno } = useGerenciamento();

  const hoje = new Date().toISOString().split("T")[0];

  const [form, setForm] = useState({
    idVenda: null,
    dataVenda: hoje,
    idCadastro: "",
    idPagto: "",
    desconto: 0,
    observacao: "",
    pago: false,
    cancelada: false
  });

  const [clientes, setClientes] = useState([]);
  const [produtos, setProdutos] = useState([]);
  const [formasPagto, setFormasPagto] = useState([]);

  const [itens, setItens] = useState([]);

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    async function carregarBase() {
      const [cli, prod, pagto] = await Promise.all([
        CadastrosInternosService.getAll(),
        ProdutosService.getComEstoque(),
        FormaPagtoService.getAtivos()
      ]);

      setClientes(cli || []);
      setProdutos(prod || []);
      setFormasPagto(pagto || []);
    }

    carregarBase();
  }, []);

  useEffect(() => {
    if (modo === "novo") {
      setItens([]);
      return;
    }

    if (modo === "alterar" && itemSelecionado) {
      setForm({
        idVenda: itemSelecionado.IDVENDA,
        dataVenda: itemSelecionado.DATAVENDA,
        idCadastro: String(itemSelecionado.IDCADASTRO),
        idPagto: String(itemSelecionado.IDPAGTO),
        desconto: itemSelecionado.desconto,
        observacao: itemSelecionado.OBSERVACAO || "",
        pago: itemSelecionado.PAGO,
        cancelada: itemSelecionado.CANCELADA
      });

      setItens(itemSelecionado.itens || []);
    }
  }, [modo, itemSelecionado]);

  function adicionarItem() {
    setItens(prev => [
      ...prev,
      {
        idProduto: "",
        quantidade: 1,
        valorUnitario: 0,
        valorTotal: 0
      }
    ]);
  }

  function removerItem(index) {
    setItens(prev => prev.filter((_, i) => i !== index));
  }

  function handleItemChange(index, campo, valor) {
    const novos = [...itens];
    novos[index][campo] = valor;

    if (campo === "idProduto") {
      const produto = produtos.find(p => p.IDPRODUTO === Number(valor));
      novos[index].valorUnitario = produto?.VALOR || 0;
    }

    novos[index].valorTotal =
      Number(novos[index].quantidade) *
      Number(novos[index].valorUnitario);

    setItens(novos);
  }

  function calcularTotal() {
    return itens.reduce((acc, i) => acc + Number(i.valorTotal || 0), 0);
  }

  function calcularTotalComDesconto() {
    return calcularTotal() - Number(form.desconto || 0);
  }

  
  function handleChange(e) {
    const { name, value, type, checked } = e.target;

    setForm(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  }

  function validarCampos() {
    const e = {};
    if (!form.idCadastro) e.idCadastro = "Informe o cliente";
    if (!form.idPagto) e.idPagto = "Informe a forma de pagamento";
    if (modo ==="novo" && itens.length === 0) e.itens = "Adicione ao menos um item";
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();

    const validation = validarCampos();
    setErrors(validation);
    if (Object.keys(validation).length > 0) return;

    setLoading(true);

    try {
      if (modo === "novo") {

          const payload = {
            dataVenda: form.dataVenda,
            idCadastro: Number(form.idCadastro),
            idPagto: Number(form.idPagto),
            desconto: Number(form.desconto),
            observacao: form.observacao,
            pago: form.pago,
            cancelada: form.cancelada,
            valorTotal: calcularTotal(),
            valorTotalComDesconto: calcularTotalComDesconto(),
            itens: itens.map(i => ({
              idProduto: Number(i.idProduto),
              quantidade: Number(i.quantidade),
              valorUnitario: Number(i.valorUnitario),
              valorTotal: Number(i.valorTotal)
            }))
          };

        await VendasService.create(vendasDTO(payload));
        setRetorno({ tipo: "sucesso", mensagem: "Venda criada com sucesso!" }); 
      }

      if (modo === "alterar") {

        await VendasService.update(
          form.idVenda,
          {
            OBSERVACAO: form.observacao,
            PAGO: form.pago,
            CANCELADA: form.cancelada
          }
        );

        setRetorno({ tipo: "sucesso", mensagem: "Venda atualizada com sucesso!" });
      }
      onClose();

    } catch(error) {

      onClose();

      setRetorno({
        tipo: "erro",
        mensagem:
          error.response?.data?.message ||
          (modo === "novo"
            ? "Erro ao criar venda."
            : "Erro ao atualizar venda.")
      });

    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="Form-Interno-Container">
      <form onSubmit={handleSubmit}>

        <div className="Form-Interno-title">
          <img src={vendaIcon} alt="vendas" className="icon" />
          {modo === "novo" ? "Nova Venda" : "Alterar Venda"}
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Cliente *</div>
          <select name="idCadastro" disabled={modo === "alterar"} value={form.idCadastro} onChange={handleChange}>
            <option value="">Selecione</option>
            {clientes.map(c => (
              <option key={c.IDCADASTRO} value={c.IDCADASTRO}>
                {c.NOME}
              </option>
            ))}
          </select>
          {errors.idCadastro && <span className="erro">{errors.idCadastro}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Forma Pagamento *</div>
          <select name="idPagto" disabled={modo === "alterar"} value={form.idPagto} onChange={handleChange}>
            <option value="">Selecione</option>
            {formasPagto.map(p => (
              <option key={p.IDPAGTO} value={p.IDPAGTO}>
                {p.descricao}
              </option>
            ))}
          </select>
          {errors.idPagto && <span className="erro">{errors.idPagto}</span>}
        </div>

        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Data</div>
          <input type="date" name="dataVenda" disabled={modo === "alterar"} value={form.dataVenda} onChange={handleChange}/>
        </div>

        <div className="Form-Interno-linha"></div>

        <div className="Form-Interno-label">Itens da venda</div><br/>

        <div className="label-itens">
          <div className="select-itens">Descrição </div> |
          <div className="input-itens">Qtde. </div> |
          <div className="input-itens">Vr. Un.</div> |
          <div className="input-itens">Vr. Tot.</div> 
        </div>

        {itens.map((item, index) => (
          <div key={index} className="Form-Interno-alinhamento-itens">
            <select
              className="select-itens"
              disabled={modo === "alterar"}
              value={item.idProduto}
              onChange={e => handleItemChange(index, "idProduto", e.target.value)}
            >
              <option value="" className="select-itens">Produto</option>
              {produtos.map(p => (
                <option key={p.IDPRODUTO} value={p.IDPRODUTO}>
                  {p.DESCRICAO}
                </option>
              ))}
            </select>

            <input
              type="number"
              min="1"
              className="input-itens"
              value={item.quantidade}
              onChange={e => handleItemChange(index, "quantidade", e.target.value)}
            />

            <input
              type="number"
              className="input-itens"
              value={item.valorUnitario}
              readOnly
            />

            <input
              type="number"
              className="input-itens"
              value={item.valorTotal}
              readOnly
            />

            <button type="button" title="remover item" className="remover-itens"onClick={() => removerItem(index)}>
              X
            </button>

          </div>
        ))}

        {modo ==="novo" && (
        <div className="Form-Interno-alinhamento-button">
          <button type="button" onClick={adicionarItem}>
            + Adicionar Item
          </button>
        </div>
        )}
        {errors.itens && <span className="erro">{errors.itens}</span>}
      
        <div className="Form-Interno-linha"></div>

        {modo ==="novo" && (
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Desconto</div>
          <input
            type="number"
            name="desconto"
            disabled={modo === "alterar"}
            value={form.desconto}
            onChange={handleChange}
          />
        </div>
        )}
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Observação</div>
          <input
            name="observacao"
            value={form.observacao}
            onChange={handleChange}
          />
        </div>

        {modo ==="novo" && (
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Total</div>
          <input value={calcularTotal().toFixed(2)} readOnly />
        </div>
        )}
        {modo ==="novo" && (
        <div className="Form-Interno-alinhamento">
          <div className="Form-Interno-label">Total c/ Desconto</div>
          <input value={calcularTotalComDesconto().toFixed(2)} readOnly />
        </div>
        )}
        <div className="Form-Interno-alinhamento">
            <div className="Form-Interno-label">Status:</div>
            <select name="pago" value={String(form.pago)} onChange={handleChange}>
              <option selected value="">Selecione</option>
              <option value='1'>Pago</option>
              <option value='0'>Pendente</option>
            </select>
        </div>

          {modo ==="alterar" && (
            <>
              <div className="Form-Interno-alinhamento">
                <div className="Form-Interno-label">Cancelar venda:</div>
                <select name="cancelada" value={String(form.cancelada)} onChange={handleChange}>
                  <option selected value="">Selecione</option>
                  <option value='1'>Sim</option>
                  <option value='0'>Não</option>
                </select>
              </div>
            </>
          )}

        <div className="Form-Interno-alinhamento-button">
          <button type="submit" disabled={loading} className="Form-Interno-button">
            {loading ? "Salvando..." : "Salvar"}
          </button>

          <button type="button" className="Form-Interno-button" onClick={onClose}>
            Voltar
          </button>
        </div>

      </form>
    </div>
  );
}